/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { CardHeader } from '../../components/CardHeader';
import axios from 'axios';
import {
  Table,
  Body,
  Head,
  Cell,
  HighlightableRow,
} from '../../components/Table';
import { MotionContainer } from '../../components/MotionContainer';
import { Loading } from '../../components/Loading';
import { usePermissions } from '../../contexts/PermissionsContext';
import { SearchInput } from '../../components/SearchInput';
import compareStrings from '../../utils/compareStrings';
import { useBreadcrumb } from '../../contexts/BreadcrumbContext';

function ZonesHome({ history, intl }) {
  const [zones, setZones] = useState([]);
  const [filteredZones, setFilteredZones] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { hasPermission } = usePermissions();
  const { setPaths } = useBreadcrumb();

  useEffect(() => {
    getZones();
    setPaths([
      {
        title: intl.formatMessage({ id: 'ZONES' }),
        pathname: `/geo-planner/zones`,
      },
    ]);
  }, []);

  async function getZones() {
    setIsLoading(true);
    try {
      const { data } = await axios.get('/zones');
      if (data) {
        setZones(data);
        setFilteredZones(data);
      }
    } finally {
      setIsLoading(false);
    }
  }

  function changeText(text) {
    setFilteredZones(
      zones.filter(x => compareStrings(JSON.stringify(x), text))
    );
  }

  function goToZone(zone) {
    if (hasPermission('floor-plans*', 'R')) {
      history.push(
        `/geo-planner/areas/${zone.areaId}/facilities/${zone.facilityId}/floor-plans/${zone.floorPlanId}?zoneId=${zone.zoneId}`,
        { from: 'zones' }
      );
    }
  }

  return (
    <MotionContainer className="card h-100" id="zones-container">
      <CardHeader
        title={intl.formatMessage({ id: 'ZONES' })}
        subtitle={intl.formatMessage({ id: 'ZONES.TITLE' })}
      />
      <div className="card-body">
        <Loading isLoading={isLoading} />
        <div className="w-25">
          <SearchInput onChange={changeText} />
        </div>
        <div className="overflow-auto">
          <Table className="mt-3">
            <Head>
              <Cell className="font-weight-normal" width={'40%'}>
                {intl.formatMessage({ id: 'ZONE_NAME' })}
              </Cell>
              <Cell className="font-weight-normal" width={'20%'}>
                {intl.formatMessage({ id: 'ZONE_ID' })}
              </Cell>
              <Cell className="font-weight-normal" width={'40%'}>
                {intl.formatMessage({ id: 'ZONE_DESCRIPTION' })}
              </Cell>
            </Head>
            <Body>
              {filteredZones.map(z => (
                <HighlightableRow key={z.zoneId} onClick={() => goToZone(z)}>
                  <Cell>{z.name}</Cell>
                  <Cell>{z.externalId}</Cell>
                  <Cell>{z.description}</Cell>
                </HighlightableRow>
              ))}
            </Body>
          </Table>
        </div>
      </div>
    </MotionContainer>
  );
}

export default injectIntl(ZonesHome);
